import CreateQrcode from '../../../components/organisms/admin/qrcode/CreateQrcode'

type Props = {}

const QrcodePage = (props: Props) => {
    return (
        <CreateQrcode />
    )
}

export default QrcodePage